import Signal from 'libs/signals';

const edoPerformanceLoansSignal = Signal({
  applications: [],
  fundingProgram: null,
});
export default edoPerformanceLoansSignal;
